import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import BasicInformation from './BasicInformation';
import LoanDetails from './LoanDetails';
import LoanPurpose from './LoanPurpose';
import Properties from './Properties';
import Quote from './Quote';
import Thanks from './Thanks';
import IToken from '@/Auth/IToken';
import { decodedTokenSelector } from '@/Auth/selectors';

export default function Router(): React.ReactElement {
    const token: IToken = useSelector(decodedTokenSelector);

    if (!token || !token.dealUuid) {
        return (
            <Routes>
                <Route element={<BasicInformation />} index={true} />
                <Route element={<Thanks />} path='/thanks' />
                <Route element={<Navigate to='/get-your-quote' />} path='/*' />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route element={<BasicInformation />} index={true} />
            <Route element={<LoanDetails />} path='/loan-amount' />
            <Route element={<LoanPurpose />} path='/loan-purpose' />
            <Route element={<Properties />} path='/properties' />
            <Route element={<Thanks />} path='/thanks' />
            <Route element={<Quote />} path='/quote' />
            <Route element={<Navigate to='/get-your-quote' />} path='/*' />
        </Routes>
    );
}

